export default __webpack_public_path__ + "static/media/copy.171cb741.svg";